import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"width":"1200px","margin":"0px auto","position":"relative"} }
const _hoisted_2 = {
  class: "tab_content",
  "element-loading-background": "transparent"
}
const _hoisted_3 = { style: {"margin-bottom":"10px"} }
const _hoisted_4 = { class: "tab_cont" }
const _hoisted_5 = { class: "num" }
const _hoisted_6 = { class: "sq_list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "li_tit" }
const _hoisted_9 = { class: "li_download" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = { style: {"margin-bottom":"16px","display":"flex","gap":"10px","align-items":"center"} }
const _hoisted_13 = { style: {"margin-top":"16px","text-align":"right"} }
const _hoisted_14 = { style: {"margin-top":"16px","text-align":"right"} }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "dialog-footer" }

import {useRouter} from "vue-router"
import {getUserRoleList, cloudExplorationVrList, createProjid, getPreServiceList} from "@/config/request";
import {reactive, ref} from "vue";
import {UploadFile, UploadFiles, UploadUserFile} from "element-plus";
import {FILE_URL, IMAGE_PREVIEW} from "@/config/const";
import {ElMessage} from "element-plus";
import {saveCloudExplorationModelRoom,savaCloudExplorationAndPreApasinfo} from "@/config/request";
import {useStore} from "vuex";
import {ElDropdown, ElDropdownMenu, ElDropdownItem} from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'VRList',
  setup(__props) {

const store = useStore()
const router = useRouter()
const dialogVisible = ref(false)
const cloudExplorationDialogVisible = ref(false)
const data = reactive({
  userInfo: {} as any,
  itemList: [] as any,
  total: 0,
  loading: true,
})

// 云勘探申报表单数据
const cloudExplorationFormData = reactive({
  applyname: '',
  applyCardtype: '',
  applyCardnumber: '',
  legalman: '',
  applyIdCard: '',
  applyTelephone: '',
  contactman: '',
  contactmanCardtype: '',
  telphone: '',
  contactmanCardnumber: '',
  servicename: '',
  servicecode: '',
  realName: '',
  userName: '',
  address: '',
  infotype: "",
  busType: "",
  status: "",
  projectname: '',
  projid: '',
  projpwd: '',
})

// 事项列表数据
const serviceList = ref<any[]>([])
const userList = ref<any[]>([])
const serviceListDialogVisible = ref(false)
const userListDialogVisible = ref(false)
const serviceListLoading = ref(false)
const userListLoading = ref(false)
// 添加分页和搜索相关变量
const searchKeyword = ref('')
const currentPage = ref(1)
const pageSize = ref(5)
const totalService = ref(0)
const totalUser = ref(0)

// 模拟数据
// 实际项目中应通过接口获取数据
// getCloudExplorationVrList() 方法会获取真实数据
// 这里保留模拟数据是为了演示效果
data.total = 8
data.itemList = [
  {
    "createTime": "2024-08-20",
    "files": '["ff80808191065a2c01916f195e8c21ea","ff80808191065a2c01916f196bec21eb","ff80808191065a2c01916f19767c21ec"]',
    "id": "1825825162369544194",
    "title": "测试123",
    "content": "测试"
  },
  {
    "createTime": "2024-10-23",
    "files": "[]",
    "id": "1848991319838535682",
    "title": "百年白记",
    "content": "https://8aafo2hiw.wasee.com/wt/8aafo2hiw"
  },
  {
    "createTime": "2024-10-23",
    "files": "[]",
    "id": "1848991389560451073",
    "title": "海底捞",
    "content": "https://8aaygakse.wasee.com/wt/8aaygakse"
  },
  {
    "createTime": "2024-10-23",
    "files": "[]",
    "id": "1848991497534418946",
    "title": "黄家老店",
    "content": "https://8aa15qdam.wasee.com/wt/8aa15qdam"
  },
  {
    "createTime": "2024-10-23",
    "files": "[]",
    "id": "1848991714639982594",
    "title": "亚朵酒店",
    "content": "https://8aaz2vdgn.wasee.com/wt/8aaz2vdgn"
  },
  {
    "createTime": "2024-10-23",
    "files": "[]",
    "id": "1848991774312345601",
    "title": "李饺哥",
    "content": "https://8aalyvh1g.wasee.com/wt/8aalyvh1g"
  },
  {
    "createTime": "2024-10-23",
    "files": "[]",
    "id": "1848991863793627137",
    "title": "木子木水",
    "content": "https://8aalyvh1g.wasee.com/wt/8aalyvh1g"
  },
  {
    "createTime": "2024-10-23",
    "files": "[]",
    "id": "1848991955753742338",
    "title": "宋园",
    "content": "https://8aalyvh1g.wasee.com/wt/8aalyvh1g"
  }
]
let dialogImageUrl = ref([])
const dialogImgVisible = ref(false)
const fileList = ref<UploadUserFile[]>([])
data.userInfo = store.state.userInfomation

const toPath = (item: any) => {
  if (JSON.parse(item.files).length > 0) {
    window.open("/VRDemo?files=" + item.files, "_blank")
  } else {
    if(item.content !== ""){
      window.open(item.content, "_blank")
    }else {
      ElMessage.error("样板间为空！")
    }
  }
}

/**
 * 获取云勘探VR列表数据
 */
const getCloudExplorationVrList = async () => {
  let res = await cloudExplorationVrList("") as any
  console.log("res111", res)
  if (res.success) {
    data.itemList = res.result?.records
    data.total = res.result.total
    data.loading = false

    console.log("data", data)
  }
}
// 初始化获取数据
getCloudExplorationVrList()

/**
 * 获取事项列表数据
 * 支持分页和搜索过滤
 */
const getServiceList = async () => {
  serviceListLoading.value = true
  try {
    let params = {
      pageNo: currentPage.value,
      pageSize: pageSize.value,
      extend1: 'ykt',
      serviceName: searchKeyword.value.trim() // 添加事项名称搜索参数
    }
    const res = await getPreServiceList(params) as any
    if (res.success) {
      serviceList.value = res.result.records || []
      totalService.value = res.result.total || 0 // 获取总条数用于分页
    } else {
      ElMessage.error('获取事项列表失败')
    }
  } catch (error) {
    ElMessage.error('获取事项列表异常')
  } finally {
    serviceListLoading.value = false
  }
}


/**
 * 打开事项选择对话框
 */
const openServiceListDialog = async () => {
  // 重置分页和搜索条件
  currentPage.value = 1
  searchKeyword.value = ''
  await getServiceList()
  serviceListDialogVisible.value = true
}

const getUserList = async () => {
  userListLoading.value = true
  try {
    let params = {
      pageNo: currentPage.value,
      pageSize: pageSize.value,
      roleId: 'sadfwer23434sfskh823r87fh283'
    }
    const res = await getUserRoleList(params) as any
    if (res.success) {
      userList.value = res.result.records || []
      totalUser.value = res.result.total || 0 // 获取总条数用于分页
    } else {
      ElMessage.error('获取事项列表失败')
    }
  } catch (error) {
    ElMessage.error('获取事项列表异常')
  } finally {
    userListLoading.value = false
  }
}
const openUserListDialog = async () => {
  // 重置分页和搜索条件
  currentPage.value = 1
  await getUserList()
  userListDialogVisible.value = true
}
const selectUser = (user: any) => {
  cloudExplorationFormData.realName = user.realName
  cloudExplorationFormData.userName = user.userName
  userListDialogVisible.value = false
}

/**
 * 分页变更处理
 */
const handlePageChange = (val: number, type: 'page' | 'size' = 'page') => {
  if (type === 'page') {
    currentPage.value = val;
  } else {
    pageSize.value = val;
  }
  getServiceList();
}

/**
 * 搜索事项列表
 */
const handleSearch = () => {
  currentPage.value = 1; // 搜索时重置到第一页
  getServiceList();
}

/**
 * 打开云勘探申报对话框
 */
const openCloudExplorationDialog = () => {
  cloudExplorationFormData.address = ''
  cloudExplorationFormData.servicename = ''
  createProjidFun()
  // 回填用户信息
  if (data.userInfo) {
    cloudExplorationFormData.applyname = data.userInfo.corpName || data.userInfo.userName
    cloudExplorationFormData.contactman = data.userInfo.userName || ''
    cloudExplorationFormData.telphone = data.userInfo.userMobile || ''
    cloudExplorationFormData.applyCardnumber = data.userInfo.certificateSno || data.userInfo.certNo
    cloudExplorationFormData.applyIdCard = data.userInfo.certNo || ''
    cloudExplorationFormData.legalman = data.userInfo.userName || ''
    cloudExplorationFormData.applyTelephone = data.userInfo.userMobile || ''
    cloudExplorationFormData.contactmanCardnumber = data.userInfo.certNo || ''
    cloudExplorationFormData.applyCardtype = data.userInfo.userType == '1' ? '111' : '001'
    cloudExplorationFormData.projpwd = '123456'
    cloudExplorationFormData.status = '待勘验'
    cloudExplorationFormData.busType = '0'
    cloudExplorationFormData.infotype = '即办件'
    cloudExplorationFormData.realName ='陈燕芹'
    cloudExplorationFormData.userName ='kfs-zmqspj086'
    cloudExplorationFormData.contactmanCardtype='111'
  }
  cloudExplorationDialogVisible.value = true
}

/**
 * 选择事项
 */
const selectService = (service: any) => {
  cloudExplorationFormData.servicename = service.serviceName || ''
  cloudExplorationFormData.servicecode = service.serviceCode || ''
  cloudExplorationFormData.projectname = service.serviceName || ''
  serviceListDialogVisible.value = false
}

/**
 * 关闭云勘探申报对话框
 */
const closeCloudExplorationDialog = () => {
  cloudExplorationDialogVisible.value = false
}

/**
 * 保存云勘探申报数据
 * 提交成功后显示包含roomId的温馨提示框
 */
const saveCloudExplorationData = async () => {
  try {
    // 模拟API调用
    console.log('云勘探申报数据:', cloudExplorationFormData)
    // 获取接口返回值，从中提取roomId
    const response = await savaCloudExplorationAndPreApasinfo(cloudExplorationFormData)
    if (response.success) {
      // 关闭对话框
      closeCloudExplorationDialog()
      const roomId = response.result.roomId

      // 弹出温馨提示框
      ElMessage.success({
        message: `您已成功申请零跑智勘，请关注中国（河南）自由贸易试验区开封片区公众号，点击公众号办事指引里零跑智勘进行登录，输入申报时所填的统一信用代码和法人手机号进行登录勘探，你的勘探验证码为【${roomId}】，请勿将验证码告知他人使用。`,
        duration: 60000, // 提示框显示30秒
        showClose: true, // 显示关闭按钮
        offset: 200, // 距离顶部100px
      })
    }else{
      ElMessage.error('云勘探申报信息提交失败，请重试')
    }

  } catch (error) {
    ElMessage.error('云勘探申报信息提交失败，请重试')
  }
}

/**
 * 打开样板间预审对话框
 */
const openDialog = () => {
  dialogImageUrl.value = []
  dialogVisible.value = true
}

/**
 * 关闭样板间预审对话框
 */
const closeDialog = () => {
  dialogVisible.value = false
}

const createProjidFun =async () =>{
  let params2 = {
    areaCode: '410296000000',
    deptCode: '001003040002008'
  }
  let result = await createProjid(params2) as any
  if(result.code == 200){
   cloudExplorationFormData.projid = result.result
  }
}

/**
 * 处理文件上传成功
 */
const handleSuccess = (response: any, uploadFile: UploadFile, uploadFiles: UploadFiles) => {
  console.log(response, uploadFile, uploadFiles)
  if (response.success) {
    let result = JSON.parse(response.result)

    dialogImageUrl.value.push(result.fileId)
    console.log("dialogImageUrl", dialogImageUrl)
  }
  console.log("fileList", fileList)
}

/**
 * 移除已上传的图片
 */
const removeItem = (value: string) => {
  let data = dialogImageUrl.value.filter(item => {
    return item != value
  })
  dialogImageUrl.value = data
  console.log("data", data)
  console.log("dialogImageUrl", dialogImageUrl.value)
}

/**
 * 保存云勘探样板间信息
 */
const saveCloudExplorationModelRoomMethod = async () => {
  let param = {
    corpName: data.userInfo.corpName,
    userName: data.userInfo.userName,
    userMobile: data.userInfo.userMobile,
    certificateSno: data.userInfo.certificateSno,
    fileId: dialogImageUrl.value.join(","),
  }
  let res = await saveCloudExplorationModelRoom(param) as any
  if (res.success) {
    dialogVisible.value = false
    ElMessage.success(res.message)
  } else {
    ElMessage.error(res.message)
  }
}

/**
 * 处理下载现场核查表
 */
const handleDownload = (command: string) => {
  let url = ''
  let fileName = ''

  if (command === 'food') {
    url = '/staticFile/现场核查表/食品餐饮类现场核查.docx'
    fileName = '食品餐饮类现场核查.docx'
  } else if (command === 'sale') {
    url = '/staticFile/现场核查表/食品销售现场核查表.docx'
    fileName = '食品销售现场核查表.docx'
  }

  // 创建a标签进行下载
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_viewer = _resolveComponent("viewer")!
  const _component_Bottom = _resolveComponent("Bottom")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[41] || (_cache[41] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "t6_breadCream" }, [
        _createElementVNode("span", null, "首页"),
        _createTextVNode(),
        _createElementVNode("i", null, ">"),
        _createTextVNode(),
        _createElementVNode("span", null, "VR样板间")
      ], -1)),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"margin-right":"10px"},
            onClick: openCloudExplorationDialog
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("云勘探申报", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: openDialog
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode("添加样板间预审", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, "共 " + _toDisplayString(data.total) + " 条数据", 1),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.itemList, (item, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.unid,
                onClick: ($event: any) => (toPath(item))
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "li_ms" }, [
                  _createElementVNode("span")
                ], -1))
              ], 8, _hoisted_7))
            }), 128)),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(ElDropdown), { onCommand: handleDownload }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_unref(ElDropdownMenu), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElDropdownItem), { command: "food" }, {
                          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                            _createTextVNode(" 食品餐饮类现场核查 ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_unref(ElDropdownItem), { command: "sale" }, {
                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                            _createTextVNode(" 食品销售现场核查表 ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _cache[29] || (_cache[29] = _createElementVNode("span", {
                      class: "el-dropdown-link",
                      style: {"cursor":"pointer","color":"#409EFF","font-size":"18px","font-weight":"500"}
                    }, [
                      _createTextVNode(" 下载现场核查表 "),
                      _createElementVNode("i", { class: "el-icon-arrow-down el-icon--right" })
                    ], -1))
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          (data.itemList.length === 0 && data.loading === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_el_empty, { description: "暂无数据" })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_dialog, {
          modelValue: cloudExplorationDialogVisible.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((cloudExplorationDialogVisible).value = $event)),
          title: "云勘探申报",
          width: "1000px",
          class: "custom-dialog"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_button, { onClick: closeCloudExplorationDialog }, {
                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                  _createTextVNode("关闭", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: saveCloudExplorationData
              }, {
                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                  _createTextVNode("提交", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "cloudExplorationForm",
              model: cloudExplorationFormData,
              "label-width": "140px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "申报单位",
                          prop: "applyname"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: cloudExplorationFormData.applyname,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cloudExplorationFormData.applyname) = $event)),
                              placeholder: "请输入申报单位",
                              disabled: true
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "统一社会信用代码",
                          prop: "applyCardnumber"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: cloudExplorationFormData.applyCardnumber,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cloudExplorationFormData.applyCardnumber) = $event)),
                              placeholder: "请输入统一社会信用代码",
                              disabled: true
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "法定代表人",
                          prop: "legalman"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: cloudExplorationFormData.legalman,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cloudExplorationFormData.legalman) = $event)),
                              placeholder: "请输入法定代表人",
                              disabled: true
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "法人身份证号",
                          prop: "applyIdCard"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: cloudExplorationFormData.applyIdCard,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cloudExplorationFormData.applyIdCard) = $event)),
                              placeholder: "请输入法人身份证号",
                              disabled: true
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "法人电话",
                          prop: "applyTelephone"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: cloudExplorationFormData.applyTelephone,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cloudExplorationFormData.applyTelephone) = $event)),
                              placeholder: "请输入法人电话",
                              disabled: true
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "联系人姓名",
                          prop: "contactman"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: cloudExplorationFormData.contactman,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cloudExplorationFormData.contactman) = $event)),
                              placeholder: "请输入联系人姓名"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "联系人证件号",
                          prop: "contactmanCardnumber"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: cloudExplorationFormData.contactmanCardnumber,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((cloudExplorationFormData.contactmanCardnumber) = $event)),
                              placeholder: "请输入联系人证件号"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "联系人手机",
                          prop: "telphone"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: cloudExplorationFormData.telphone,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((cloudExplorationFormData.telphone) = $event)),
                              placeholder: "请输入联系人手机"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "勘探事项名称",
                          prop: "serviceName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: cloudExplorationFormData.servicename,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((cloudExplorationFormData.servicename) = $event)),
                              placeholder: "请选择勘探事项名称",
                              readonly: "",
                              style: {"flex":"1"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: openServiceListDialog,
                              style: {"margin-left":"10px"}
                            }, {
                              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                _createTextVNode("选择", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "审批人",
                          prop: "serviceName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: cloudExplorationFormData.realName,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((cloudExplorationFormData.realName) = $event)),
                              placeholder: "请选择审批人",
                              readonly: "",
                              style: {"flex":"1"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: openUserListDialog,
                              style: {"margin-left":"10px"}
                            }, {
                              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                _createTextVNode("选择", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "地址",
                          prop: "address"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              autosize: "",
                              modelValue: cloudExplorationFormData.address,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((cloudExplorationFormData.address) = $event)),
                              placeholder: "请输入地址"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: serviceListDialogVisible.value,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((serviceListDialogVisible).value = $event)),
          title: "选择事项",
          width: "900px",
          "close-on-click-modal": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_input, {
                modelValue: searchKeyword.value,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((searchKeyword).value = $event)),
                placeholder: "请输入事项名称搜索",
                style: {"flex":"1"},
                clearable: "",
                onKeyup: _withKeys(handleSearch, ["enter"]),
                disabled: serviceListLoading.value
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: handleSearch,
                loading: serviceListLoading.value
              }, {
                default: _withCtx(() => [
                  (!serviceListLoading.value)
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Search)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Loading)
                        ]),
                        _: 1
                      })),
                  _cache[34] || (_cache[34] = _createTextVNode(" 搜索 ", -1))
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: serviceList.value,
              style: {"width":"100%"},
              "element-loading-text": "加载中...",
              "highlight-current-row": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  label: "序号",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "serviceCode",
                  label: "事项编码",
                  width: "200"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "serviceName",
                  label: "事项名称",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "100",
                  fixed: "right"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: ($event: any) => (selectService(scope.row)),
                      disabled: serviceListLoading.value,
                      class: "select-btn"
                    }, {
                      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                        _createTextVNode(" 选择 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, serviceListLoading.value]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_pagination, {
                "current-page": currentPage.value,
                "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => ((currentPage).value = $event)),
                "page-size": pageSize.value,
                "onUpdate:pageSize": _cache[14] || (_cache[14] = ($event: any) => ((pageSize).value = $event)),
                total: totalService.value,
                "page-sizes": [5, 10, 20],
                layout: "total, sizes, prev, pager, next, jumper",
                onSizeChange: _cache[15] || (_cache[15] = (val) => handlePageChange(val, 'size')),
                onCurrentChange: _cache[16] || (_cache[16] = (val) => handlePageChange(val, 'page')),
                disabled: serviceListLoading.value
              }, null, 8, ["current-page", "page-size", "total", "disabled"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: userListDialogVisible.value,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((userListDialogVisible).value = $event)),
          title: "选择审批人员",
          width: "500px",
          "close-on-click-modal": false
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: userList.value,
              style: {"width":"100%"},
              "element-loading-text": "加载中...",
              "highlight-current-row": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  label: "序号",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "realName",
                  label: "审批人员",
                  width: "220",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "100",
                  fixed: "right"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: ($event: any) => (selectUser(scope.row)),
                      disabled: userListLoading.value,
                      class: "select-btn"
                    }, {
                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                        _createTextVNode(" 选择 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, userListLoading.value]
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_pagination, {
                "current-page": currentPage.value,
                "onUpdate:currentPage": _cache[18] || (_cache[18] = ($event: any) => ((currentPage).value = $event)),
                "page-size": pageSize.value,
                "onUpdate:pageSize": _cache[19] || (_cache[19] = ($event: any) => ((pageSize).value = $event)),
                total: totalUser.value,
                "page-sizes": [5, 10, 20],
                layout: "total, sizes, prev, pager, next, jumper",
                onSizeChange: _cache[20] || (_cache[20] = (val) => handlePageChange(val, 'size')),
                onCurrentChange: _cache[21] || (_cache[21] = (val) => handlePageChange(val, 'page')),
                disabled: userListLoading.value
              }, null, 8, ["current-page", "page-size", "total", "disabled"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((dialogVisible).value = $event)),
          title: "添加样板间预审",
          width: "1000"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_button, { onClick: closeDialog }, {
                default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                  _createTextVNode("关闭", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: saveCloudExplorationModelRoomMethod
              }, {
                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                  _createTextVNode(" 提交 ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              "show-file-list": false,
              action: _unref(FILE_URL),
              "on-success": handleSuccess,
              style: {"margin-bottom":"10px"}
            }, {
              trigger: _withCtx(() => [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                    _createTextVNode("上传图片", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["action"]),
            _createVNode(_component_viewer, { images: _unref(dialogImageUrl) }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dialogImageUrl), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"display":"inline-block","position":"relative"},
                    key: index
                  }, [
                    _createElementVNode("img", {
                      style: {"margin-right":"10px","box-shadow":"rgba(149, 157, 165, 0.2) 0px 8px 24px","width":"200px","height":"140px"},
                      src: _unref(IMAGE_PREVIEW)+item
                    }, null, 8, _hoisted_15),
                    _createElementVNode("span", {
                      class: "removePic",
                      onClick: ($event: any) => (removeItem(item))
                    }, "×", 8, _hoisted_16)
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["images"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])), [
        [_directive_loading, data.loading]
      ])
    ]),
    _createVNode(_component_Bottom)
  ]))
}
}

})